module.exports = __webpack_public_path__ + "img/img1.06912f6e.png";